export const getHasClickedWelcomePagePrompts = state => {
  var _state$aiPromptsInter;
  return ((_state$aiPromptsInter = state.aiPromptsInteraction) === null || _state$aiPromptsInter === void 0 ? void 0 : _state$aiPromptsInter.hasClickedWelcomePagePrompts) || false;
};